import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import Loading from '../../Loading';
import { Tooltip } from 'react-tippy';
import ChatGroupCreator from '../ChatGroupCreator';
import { observer, inject } from 'mobx-react';
import { makeObservable, observable } from 'mobx';

import setGlobalErrors from '../../../actions/setGlobalErrors';

class ChatUsersEditor extends Component {
  show_add_users=false;
  users={items:[],inited:false,fetching:false};
  selected_users=[];



  constructor(props) {
    super(props);
    makeObservable(this,{
      show_add_users:observable,
      users:observable,
      selected_users:observable,
    });

    this.state={
      show_add_users:false,
      users:{
        items:[],
        inited:false,
        fetching:false,
      },
      selected_users:[],
    }
  }
  loadCurUsers() {
    this.users.fetching=true;
    axios.get(`/api/privatechat/${this.props.chat_id}`).then((data)=>{
      this.users={
        fetching:false,
        inited:true,
        items:data.data.answer.items,
      };
    });
  }
  componentDidMount() {
    this.loadCurUsers();
  }
  promoteUser(user) {
    axios.post(`/api/privatechat/${user.chat_id}/promote`,{ nick:user.user_table_nick }).then((data)=>{
      if(data.data.errors) {
        this.props.setGlobalErrors(data.data.errors);
      }
      if(data.data.answer) {
        this.loadCurUsers();
      }
    });
  }
  demoteUser(user) {
    axios.post(`/api/privatechat/${user.chat_id}/demote`,{ nick:user.user_table_nick }).then((data)=>{
      if(data.data.errors) {
        this.props.setGlobalErrors(data.data.errors);
      }
      if(data.data.answer) {
        this.loadCurUsers();
      }
    });
  }
  kickUser(user) {
    axios.post(`/api/privatechat/${user.chat_id}/kick`,{ nick:user.user_table_nick }).then((data)=>{
      if(data.data.errors) {
        this.props.setGlobalErrors(data.data.errors);
      }
      if(data.data.answer) {
        this.loadCurUsers();
      }
    });
  }
  renderUsers() {
    const items=this.users.items.map((user)=> {
      return (
        <div key={user.id}>
          <div className="up12 splice" style={{height: 50}}>
            <div className="cell s-shrink s-middle">
              {user.user_table_avatar ? (
                <img src={`/autoresize/100x100xC/${user.user_table_avatar}`} alt="" className="db rad4" style={{width: 40}}/>
              ) : (
                <div className="bg-w3 rad4" style={{width: 40, height: 40}}></div>
              )}
            </div>
            <div className="cell s-auto s-middle">
              <div className="pleft10">
                {user.user_table_nick}
                {user.admin=='1'?(
                  <i className="mdi mdi-shield-account const2 fs20 pleft5 vam lh10"></i>
                ):null}
              </div>
            </div>
            {this.props.meStore.me.data.id !== user.user_id?(
              <div className="cell s-shrink s-middle">

                {user.admin=='1'?(
                  <Tooltip html={(<div className="fs14">{this.props.translateStore.t.evaPrivateChat.user_demote}</div>)}>
                    <span className="dib rad4 bg-sc1 hpadd5 w1 mright5 pointer" onClick={()=>{ this.demoteUser(user); }}>
                      <i className="mdi mdi-shield-account fs14"></i>
                    </span>
                  </Tooltip>
                  ):(
                  <Tooltip html={(<div className="fs14">{this.props.translateStore.t.evaPrivateChat.user_promote}</div>)}>
                    <span className="dib rad4 bg-pc1 hpadd5 w1 mright5 pointer" onClick={()=>{ this.promoteUser(user); }}>
                      <i className="mdi mdi-shield-account fs14"></i>
                    </span>
                  </Tooltip>
                )}

                <Tooltip html={(<div className="fs14">{this.props.translateStore.t.evaPrivateChat.user_kick}</div>)}>
                  <span className="dib rad4 bg-pc1 hpadd5 w1 pointer" onClick={()=>{ this.kickUser(user); }}>
                    <i className="mdi mdi-karate fs14"></i>
                  </span>
                </Tooltip>

              </div>
            ):null}
          </div>
        </div>
      )
    });
    return (
      <div>
        {items}
        <div className="tar ptop20">
          <span className="btn1" onClick={()=>{ this.props.done(); }} ><span>Ок</span></span>
        </div>
      </div>
    )
  }
  render() {
    if(!this.users.inited) {
      return (
        <Loading />
      )
    }

    if(this.show_add_users) {
      return (
        <div className="up12-v splice s-v-nowrap h100 bg-w1">
          <div className="v-cell s-v-shrink">
            <div className="padd10">
              <div className="up12 splice">
                <div className="cell s-auto">
                  <span className={`btn2 ${this.props.standalone?'small':'small'}`} onClick={()=>{ this.show_add_users=false; }}><span><i className="mdi mdi-arrow-left op50"></i>{this.props.translateStore.t.evaPrivateChat.cancel}</span></span>
                </div>
                {this.selected_users.length>0?(
                  <div className="cell s-shrink">
                    <span className={`btn1 ${this.props.standalone?'small':'small'}`} onClick={()=>{ if(this._creatorWrap) { this._creatorWrap.addUsersClick(); } }}><span>ОК</span></span>
                  </div>
                ):null}
              </div>
            </div>
          </div>
          <div className="v-cell s-v-auto">
            <ChatGroupCreator
              standalone={this.props.standalone}
              ref={(ref)=>{ if(ref) { this._creatorWrap=ref; } }}
              mode="add" chat_id={this.props.chat_id}
              done={()=>{ this.loadCurUsers(); this.show_add_users=false; console.log('DONE CLICK!!!'); }}
              selectedChange={(selected)=>{ this.selected_users=selected; }}
            />
          </div>
        </div>
      )
    }

    return (
      <div className="bg-w1">
        <div className="padd10">
          <div className="pbottom10">
            <span className="btn1 small" onClick={()=>{ this.show_add_users=true; }}><span><i className="mdi mdi-account-plus-outline op50"></i>{this.props.translateStore.t.evaPrivateChat.add_user}</span></span>
          </div>
          {this.renderUsers()}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    t:state.translate,
    me:state.me,
  }
}

export default inject("translateStore","meStore","appStateStore")(observer(ChatUsersEditor));